import { on } from '@disy/lib/event-util';
import { clamp } from '@disy/lib/math';
import { px } from '@disy/lib/px';
import { tearDown } from '@disy/lib/teardown';
import { throttle } from '@disy/lib/throttle';

import { applyGlobalCursor } from 'cadenza/utils/global-cursor/global-cursor';
import {
  getBounds,
  getPosition,
  getViewPortWithoutScrollSize,
} from 'cadenza/workbook/selection-cart/layout/layout-utils';
import type { SelectionCart } from 'cadenza/workbook/selection-cart/selection-cart';

export function handleSelectionCartMoving(
  pointerDownEvent: PointerEvent,
  selectionCart: SelectionCart,
  relativeContainer: HTMLElement,
  globalCursorSourceId: string,
) {
  const selectionCartRect = selectionCart.getBoundingClientRect();
  const [viewPortWidth, viewPortHeight] = getViewPortWithoutScrollSize();
  // fixed position from view port
  const position = getPosition(selectionCartRect, new DOMRect(0, 0, viewPortWidth, viewPortHeight));
  relativeContainer.classList.add('disable-user-selection');
  selectionCart.classList.add('is-moving');
  const { clientX: x, clientY: y } = pointerDownEvent;
  // Drag only within view-port bounds.
  const { maxBottom, maxLeft, maxRight, maxTop, minBottom, minLeft, minRight, minTop } = getBounds(
    selectionCartRect,
    viewPortWidth,
    viewPortHeight,
  );
  const eventKeys = [
    on(
      window,
      ['pointermove', 'touchmove'],
      throttle((event: PointerEvent | TouchEvent) => {
        applyGlobalCursor('move', globalCursorSourceId);
        const newX = event instanceof PointerEvent ? event.clientX : event.targetTouches[0].clientX;
        const newY = event instanceof PointerEvent ? event.clientY : event.targetTouches[0].clientY;
        // deltas between initial mouse down and current mouse position
        const dx = newX - x;
        const dy = newY - y;

        selectionCart.style.top = px(clamp(position.top + dy, minTop, maxTop));
        selectionCart.style.right = px(clamp(position.right - dx, minRight, maxRight));
        selectionCart.style.bottom = px(clamp(position.bottom - dy, minBottom, maxBottom));
        selectionCart.style.left = px(clamp(position.left + dx, minLeft, maxLeft));
        selectionCart.markManualPosition();
      }, 30),
    ),
    on(window, 'pointerup', () => {
      // cleanup after drag is done
      tearDown(eventKeys);
      applyGlobalCursor('', globalCursorSourceId);
      relativeContainer.classList.remove('disable-user-selection');
      selectionCart.classList.remove('is-moving');
      selectionCart.storeLastPosition();
    }),
  ];
}
